import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { mapResourceNameToReduxSelector } from "../../../selectors/resources";
import useCountSelectedProvisionedApps from "./useCountSelectedProvisionedApps";
import { confirmbox_open } from "../../../components/confirmbox/reducer/actions";

const warnOnEmptyOrInvalidList = (
  actionType: string,
  selectedCount: number,
) => {
  if (selectedCount === 0) {
    toast.warn(`No stacks are selected to ${actionType}.`);
  } else {
    toast.warn(`Cannot perform ${actionType} on the selected stacks.`);
  }
};

const useProvisionedAppsMultiActions = () => {
  const resourceType: keyof typeof mapResourceNameToReduxSelector =
    "marketplace_provisioned_apps";

  const {
    resourcesList: provisionedAppList,
    selectedResources: selectedMarketplaceProvisionedApps,
  } = useSelector(mapResourceNameToReduxSelector[resourceType]);

  const dispatch = useDispatch();

  const validList = selectedMarketplaceProvisionedApps.map(
    (x) => provisionedAppList[x],
  );

  const { multiActionsCount } = useCountSelectedProvisionedApps();

  const onMultipleDelete = useCallback(() => {
    if (multiActionsCount === 0) {
      warnOnEmptyOrInvalidList(
        "delete",
        selectedMarketplaceProvisionedApps.length,
      );
    } else {
      dispatch(
        confirmbox_open({
          entity: "Provisioned App",
          operation: "delete",
          resources: validList,
        }),
      );
    }
  }, [
    dispatch,
    multiActionsCount,
    selectedMarketplaceProvisionedApps.length,
    validList,
  ]);

  return {
    onMultipleDelete,
  };
};

export default useProvisionedAppsMultiActions;
